var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"mb-10"},[_c('h3',{staticClass:"mb-10"},[_vm._v(_vm._s(_vm.$t("message.schedule-management")))]),_c('br'),_c('FullCalendar',{staticClass:"full-calendar",attrs:{"options":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }